import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../LoginPage/Login.css';
import loginimg from '../img/SugramTravel.jpg';
import LogoCM from '../img/Logo.jpg';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from '../config';
import 'bootstrap-icons/font/bootstrap-icons.css';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      showPassword: false, // added state for toggling password visibility,
      loading: false,
      data: null,

    };
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("SelectedValue")
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit1=()=>{
    debugger
    var username = "sugramtravel@gmail.com"
    var password = "sugram@123"

    if(username === this.state.email && password === this.state.password ){
      toast.success("Login successful!");
      window.location.href = '/TicketBooking';
    }
    else{
      toast.error("Invalid Credential !");
      
    }
  
  }
  handleSubmit = (event) => {
    event.preventDefault();
    // this.setState({ loading: true });
    this.setState({ loading: true });

    fetch(API_URL + '/api/login/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: this.state.email,
        password: this.state.password
      })
    })
      .then(response => response.json())
      .then(data => {
        // this.setState({ loading: true });
        if (data.message === 'Login successful') {
          // Save token to local storage
          localStorage.setItem('token', data.token);
          localStorage.setItem('role', data.role);
          // Show success toast
          toast.success("Login successful!");
          setTimeout(() => {
            sessionStorage.setItem('UserName', data.username);
            // window.location.href = '/TicketBooking';

          }, 1000);
        } else {
          //   Swal.fire({
          //     title: 'Invalid Credential !',
          //     icon: 'warning',
          //     confirmButtonText: 'Ok',
          // })
          // toast.error("Invalid Credential !");
        }
      })
      .catch(error => {
        console.error('Error:', error);
        toast.error("An error occurred. Please try again.");
      })
  }


  // Function to toggle password visibility
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  };

  render() {
    return (
      <>
        <div>
          <section className="vh-40" style={{ width: "100%" }}>
            <div className="top-bar"></div>
            {/* <nav className="navbar navbar-light bg-light"> */}
              {/* <a className="navbar-brand" href="#"> */}
              {/* <div className="d-flex align-items-center">
                <img src={LogoCM} width="220" height="50" className="d-inline-block align-top" alt="" style={{ marginLeft: "20px" }} />
              </div> */}
              {/* </a> */}
            {/* </nav> */}
            <div className="container h-100">
              <div className="media_css row align-items-center justify-content-center h-100" style={{ marginTop: "10px", backgroundColor: "#f9fbfd", width: "100%", marginLeft: "93px" }}>
                <div className="col-md-5 col-lg-5 col-xl-5">
                  <img src={loginimg} style={{ marginLeft: "-101px", width: "100%" }} className=" media_css_img img-fluid" alt="laptop" height="70" />
                </div>
                <div className="col-md-5 col-lg-5 col-xl-5 mt-4">
                  <div className="login-header" style={{ marginBottom: "55px" }}>
                    <h2>Log in to Sugram Travel</h2>
                    <h6 style={{ marginTop: "18px" }}>Enter your details below</h6>
                  </div>
                  <form onSubmit={this.handleSubmit}>
                    <div className="col-md-10 mb-3">
                      <input
                        type="email"
                        placeholder='Enter your username'
                        id="floatingInput"
                        name="email"
                        className="form-control"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="col-md-10 mb-3">
                      <div className="input-group">
                        <input
                          type={this.state.showPassword ? 'text' : 'password'}
                          id="floatingPassword"
                          placeholder="Enter your password"
                          className="form-control"
                          name="password"
                          value={this.state.password}
                          onChange={this.handleInputChange}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => this.togglePasswordVisibility()}
                        >
                          {this.state.showPassword ? (
                            <i className="bi bi-eye-slash-fill"></i>
                          ) : (
                            <i className="bi bi-eye-fill"></i>
                          )}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-10 mb-3">
                      <button type="submit" onClick={this.handleSubmit1} style={{ width: '100%', color: 'white' }} className="btn-sm buttonBorder1G">
                        Log In
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
            <ToastContainer />
          </section>
        </div>
      </>
    );
  }
}

export default Login;
